import { usePaperWidthField } from '@/features/settings/components/PrinterConfiguration/form'
import { getPaperWidthOptions } from '@/features/settings/components/PrinterConfiguration/form/utils/getPaperWidthOptions'
import LabeledSelect from '@/features/settings/components/forms/LabeledSelect'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const PaperWidthField: FC = () => {
    const { t } = useTranslation()

    const [value, onChange] = usePaperWidthField()

    return (
        <LabeledSelect
            value={value}
            onValueChange={onChange}
            label={t('settings.printers.printerConfiguration.field.paperWidth.label')}
            options={getPaperWidthOptions(
                t('settings.printers.printerConfiguration.field.paperWidth.unit')
            )}
        />
    )
}

export default PaperWidthField
